import React from 'react';

function Notes2() {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0752 13.0482L25.8502 18.2732C24.8002 22.7857 22.7252 24.6107 18.8252 24.2357C18.2002 24.1857 17.5252 24.0732 16.8002 23.8982L14.7002 23.3982C9.48772 22.1607 7.87522 19.5857 9.10022 14.3607L10.3252 9.12318C10.5752 8.06068 10.8752 7.13568 11.2502 6.37318C12.7127 3.34818 15.2002 2.53568 19.3752 3.52318L21.4627 4.01068C26.7002 5.23568 28.3002 7.82318 27.0752 13.0482Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8269 24.2375C18.0519 24.7625 17.0769 25.2 15.8894 25.5875L13.9144 26.2375C8.95189 27.8375 6.33939 26.5 4.72689 21.5375L3.12689 16.6C1.52689 11.6375 2.85189 9.0125 7.81439 7.4125L9.78939 6.7625C10.3019 6.6 10.7894 6.4625 11.2519 6.375C10.8769 7.1375 10.5769 8.0625 10.3269 9.125L9.10189 14.3625C7.87689 19.5875 9.48939 22.1625 14.7019 23.4L16.8019 23.9C17.5269 24.075 18.2019 24.1875 18.8269 24.2375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8008 10.6641L21.8633 12.2016"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5742 15.5L18.1992 16.425"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Notes2;
